// PlannerHeader Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'

import FieldDate from '../../form/field_date/field_date.jsx'
import IconButton from '../../common/icon_button/icon_button.jsx'
import Button from '../../common/button/button.jsx'
import PlannerHeaderWeek from '../planner_headerweek/planner_headerweek.jsx'
import PlannerHeaderDay from '../planner_headerday/planner_headerday.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import PlannerHeaderKanban from '../planner_headerkanban/planner_headerkanban.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'

class PlannerHeader extends Component {
  constructor (props) {
    super(props)

    this._references = {
      content: React.createRef()
    }
  }

  static get propTypes () {
    return {
      viewMode: PropTypes.string,
      dayItems: PropTypes.array,
      weekItems: PropTypes.array,
      fromDate: PropTypes.object,
      toDate: PropTypes.object,
      kanbanInfo: PropTypes.object,
      onClickPrevious: PropTypes.func,
      onClickNext: PropTypes.func,
      onChangeMode: PropTypes.func,
      onChangeDate: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      viewMode: 'day',
      dayItems: [],
      weekItems: [],
      fromDate: null,
      toDate: null,
      kanbanInfo: null,
      onClickPrevious: null,
      onClickNext: null,
      onChangeMode: null,
      onChangeDate: null
    }
  }

  _getDisplaySubtitle () {
    return (
      <div className='fromdate'>
        <span>
          <IntlMessage ident='plannerv2.task.plannerFromDate' />
        </span>
        {`${DateUtil.getDisplayDate(this.props.fromDate)}`}
      </div>
    )
  }

  render () {
    const {
      viewMode,
      fromDate,
      toDate,
      onClickPrevious,
      onClickNext,
      onChangeMode,
      onChangeDate
    } = this.props
    const isCalendarMode = viewMode !== 'kanban'
    let displayText = '-'
    let displaySubtitle = ''

    if (fromDate && toDate) {
      displayText = `${DateUtil.getDisplayMonth(
        fromDate
      )} - ${DateUtil.getDisplayMonth(toDate)}`
      displaySubtitle = this._getDisplaySubtitle()
    }

    return (
      <div className='planner-header'>
        <div className='titleinfo'>
          <div className='datecont'>
            <FieldDate
              name='dueDate'
              value='dueDate'
              displayText={displayText}
              subtitle={displaySubtitle}
              isSingleDate={isCalendarMode}
              startDate={fromDate}
              endDate={isCalendarMode ? null : toDate}
              onChange={onChangeDate}
            />
          </div>
          {isCalendarMode && (
            <div className='actioncont'>
              <Button
                type='primary'
                title='plannerv2.task.plannerDayTitle'
                rounded
                invert={viewMode === 'week'}
                className='plannermode day'
                hasBorder
                onClick={(ev) => onChangeMode && onChangeMode('day', ev)}
              />
              <Button
                type='default'
                title='plannerv2.task.plannerWeekTitle'
                rounded
                active={viewMode === 'week'}
                className='plannermode week'
                onClick={(ev) => onChangeMode && onChangeMode('week', ev)}
              />
            </div>
          )}
          <div className='navcont'>
            {isCalendarMode && (
              <IconButton
                className='fieldaction'
                icon='arrow-left'
                type='default'
                canHover
                onClick={onClickPrevious}
              />
            )}
          </div>
        </div>
        <div
          className={`dateinfo${
            viewMode === 'kanban' ? ' dateinfokanban' : ''
          }`}
          ref={this._references.content}
        >
          {viewMode === 'week' && this._renderWeekItems()}
          {viewMode === 'kanban' && this._renderKanbanItems()}
          {viewMode === 'day' && this._renderDayItems()}
        </div>
        <div className='actioninfo'>
          {isCalendarMode && (
            <IconButton
              className='fieldaction'
              icon='arrow-right'
              type='default'
              canHover
              onClick={onClickNext}
            />
          )}
        </div>
      </div>
    )
  }

  _renderWeekItems () {
    const { weekItems } = this.props

    return weekItems.map((weekItem) => (
      <PlannerHeaderWeek
        key={`${weekItem.year}-${weekItem.weekNo}`}
        item={weekItem}
      />
    ))
  }

  _renderKanbanItems () {
    const { kanbanInfo } = this.props

    return (
      <>
        <PlannerHeaderKanban
          title='plannerv2.planner.taskInfoTitleTodo'
          type='todo'
          count={kanbanInfo.countTodo || 0}
        />
        <PlannerHeaderKanban
          title='plannerv2.planner.taskInfoTitleInProgress'
          type='inprogress'
          count={kanbanInfo.countInProgress || 0}
        />
        <PlannerHeaderKanban
          title='plannerv2.planner.taskInfoTitleDone'
          type='completed'
          count={kanbanInfo.countCompleted || 0}
        />
      </>
    )
  }

  _renderDayItems () {
    const { dayItems } = this.props

    return <PlannerHeaderDay items={dayItems} />
  }

  getContentWidth () {
    if (this._references.content.current) {
      const { width } = ReactDOM.findDOMNode(
        this._references.content.current
      ).getBoundingClientRect()
      return width
    }

    return 0
  }
}

export default PlannerHeader
